export default ((length, {
  message = `This field should be exactly ${length} character${length > 1 ? 's' : ''} long`
} = {}) => value => value && value.length === length ? null : message);